/**
 *
 * Asynchronously loads the component for StripePaymentPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
